import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { SignInForm } from '@features/Auth';
import { useSuperAdminSignIn } from '@features/Auth/SuperAdminSignIn/hooks/useSuperAdminSignIn';
import { Button } from '@mui/material';
import { UnauthenticatedPath } from '@shared/constants/routes.constants';
import { useStyles } from '../styles';

export const SuperAdminSignInPage: React.FC = () => {
  const { onSubmit, control, setValue, errorMsg, formState } = useSuperAdminSignIn();
  const navigate = useNavigate();
  const { classes } = useStyles();

  return (
    <PageContainer title="Sign in (root admin)" useProductSuffix>
      <AuthLayout className={classes.layout}>
        <div className={classes.root}>
          <Button
            className={classes.switchButton}
            variant="contained"
            disableElevation
            onClick={() => navigate(UnauthenticatedPath.SIGN_IN)}>
            Sign in as admin
          </Button>
          <SignInForm
            title="Sign in (as root admin)"
            onSubmit={onSubmit}
            control={control}
            setValue={setValue}
            errorMsg={errorMsg}
            formState={formState}
          />
        </div>
      </AuthLayout>
    </PageContainer>
  );
};
